import React, { useMemo } from "react"

import { AgentHistory, AgentHistoryContext } from "@plugins/providers/agent/AgentHistoryContext"

import { useUserSession } from "@session/UserSession"

interface AgentChatProviderProps {
    children: React.ReactNode
}
export function AgentHistoryProvider({ children }: Readonly<AgentChatProviderProps>) {
    const { client, user } = useUserSession()
    const search = useMemo(() => {
        return new AgentHistory(client, user?.sub, 100)
    }, [client, user?.sub])

    return <AgentHistoryContext.Provider value={search}>{children}</AgentHistoryContext.Provider>
}
